import React, { ReactElement } from 'react';
import { format, fromUnixTime } from 'date-fns';
import { AgentRequestResponse } from '../../structures/response/AgentRequestResponse';
import {
  NumericCellValue,
  StringCellValue,
} from '../UI/MfResponsiveTable/MfResponsiveTable';
import PhoneCell from './TableCustomCells/PhoneCell';
import { ruble } from '../../helpers/formatHelper';
import StatusCell from './TableCustomCells/StatusCell';
import ActionCell from './TableCustomCells/ActionCell';

export function getTableData(
  data: AgentRequestResponse[],
  onEdit: (v: AgentRequestResponse) => void,
  onView: (v: AgentRequestResponse) => void,
  onCallback: (v: AgentRequestResponse) => void,
  onSign: (v: AgentRequestResponse) => void,
  onPledgeConfirm: (v: AgentRequestResponse) => void
): (string | ReactElement)[][] {
  return data.map((v) => [
    <StringCellValue>{v.id}</StringCellValue>,
    <StringCellValue>{v.inn}</StringCellValue>,
    <StringCellValue>{v.companyName ?? '—'}</StringCellValue>,
    <StringCellValue>{v.contactName}</StringCellValue>,
    <PhoneCell phone={v.contactPhone} />,
    <NumericCellValue>
      {v.amountRequested ? ruble(+v.amountRequested) : '—'}
    </NumericCellValue>,
    <NumericCellValue>
      {v.termRequested ? `${v.termRequested} мес` : '—'}
    </NumericCellValue>,
    <NumericCellValue>
      {v.offerAmountActual ? ruble(+v.offerAmountActual) : '—'}
    </NumericCellValue>,
    <NumericCellValue>
      {+v.amountToPay ? ruble(+v.amountToPay) : '—'}
    </NumericCellValue>,
    <StringCellValue>
      {format(fromUnixTime(v.createdAt), 'dd.MM.yyyy')}
    </StringCellValue>,
    <StatusCell
      agentRequest={v}
      onSign={onSign}
      onPledgeConfirm={onPledgeConfirm}
    />,
    <StringCellValue>
      {v.reasonRefusal ? v.reasonRefusal : '—'}
    </StringCellValue>,
    <ActionCell
      agentRequest={v}
      onEdit={onEdit}
      onCallback={onCallback}
      onView={onView}
    />,
  ]);
}
